import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";

export interface PickupDetailsResponse {
  pickupNumber: number;
  pickupBusinessName: string;
  pickupAddress1: string;
  pickupAddress2: string;
  pickupCity: string;
  pickupState: string;
  pickupZip: string;
  pickupPhoneNumber: number;
  pickupContactName: string;
}

export const GetPickupDetailsAPI = async (
  pickupNumber: string | number
): Promise<PickupDetailsResponse> => {
  try {
    const pickupNumberStr = (pickupNumber ?? "").toString().trim();
    const url = getUrl(ApiType.PICKUP_DETAILS).replace(
      ":pickupNumber",
      encodeURIComponent(pickupNumberStr)
    );

    const response = await axios.get(url);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.pickupDetailsAPIError, {
      badRequestOrder: "errorsFirst",
    });
  }
};
